/**
 * NOTE: do not directly import this. It should only be consumed via the {@see LocalesLazy} token.
 *
 * Purpose: Required to only import the languages we support for localization.
 * 	Any languages we support in the future need to be added to the list manually.
 */
import ar from '../../../../node_modules/@angular/common/locales/ar.mjs';
import cs from '../../../../node_modules/@angular/common/locales/cs.mjs';
import da from '../../../../node_modules/@angular/common/locales/da.mjs';
import en from '../../../../node_modules/@angular/common/locales/en.mjs';
// lowercase and with an underscore instead of an - for easy parsing
import en_gb from '../../../../node_modules/@angular/common/locales/en-GB.mjs';
import es from '../../../../node_modules/@angular/common/locales/es.mjs';
import es_419 from '../../../../node_modules/@angular/common/locales/es-419.mjs';
import fr from '../../../../node_modules/@angular/common/locales/fr.mjs';
import de from '../../../../node_modules/@angular/common/locales/de.mjs';
import el from '../../../../node_modules/@angular/common/locales/el.mjs';
import he from '../../../../node_modules/@angular/common/locales/he.mjs';
import hu from '../../../../node_modules/@angular/common/locales/hu.mjs';
import id from '../../../../node_modules/@angular/common/locales/id.mjs';
import it from '../../../../node_modules/@angular/common/locales/it.mjs';
import ja from '../../../../node_modules/@angular/common/locales/ja.mjs';
import ko from '../../../../node_modules/@angular/common/locales/ko.mjs';
import nl from '../../../../node_modules/@angular/common/locales/nl.mjs';
import pl from '../../../../node_modules/@angular/common/locales/pl.mjs';
import pt from '../../../../node_modules/@angular/common/locales/pt.mjs';
import ro from '../../../../node_modules/@angular/common/locales/ro.mjs';
import ru from '../../../../node_modules/@angular/common/locales/ru.mjs';
import sv from '../../../../node_modules/@angular/common/locales/sv.mjs';
import th from '../../../../node_modules/@angular/common/locales/th.mjs';
import tr from '../../../../node_modules/@angular/common/locales/tr.mjs';
import vi from '../../../../node_modules/@angular/common/locales/vi.mjs';
import zh from '../../../../node_modules/@angular/common/locales/zh.mjs';

const Locales = {
  ar,
  cs,
  da,
  en,
  en_gb,
  es,
  es_419,
  fr,
  de,
  el,
  he,
  hu,
  id,
  it,
  ja,
  ko,
  nl,
  pl,
  pt,
  ro,
  ru,
  sv,
  th,
  tr,
  vi,
  zh,
};

export { Locales };
